module.exports = __webpack_public_path__ + "img/1716360065186-WhatsApp Image 2024-05-22 at 14.39.08.jpeg.38f4e48b.webp";